import { render, staticRenderFns } from "./PracticeCatalogList.vue?vue&type=template&id=3488eb23&scoped=true&lang=pug"
import script from "./PracticeCatalogList.vue?vue&type=script&lang=js"
export * from "./PracticeCatalogList.vue?vue&type=script&lang=js"
import style0 from "./PracticeCatalogList.vue?vue&type=style&index=0&id=3488eb23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3488eb23",
  null
  
)

export default component.exports